import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";
import { subActivityList } from "constants/subActivity";

export const getSubActivityList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.subActivity_list(pageNum, filters);
    dispatch({ type: subActivityList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: subActivityList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};
